import { render, staticRenderFns } from "./BigButtonGroup.vue?vue&type=template&id=8a014238&scoped=true"
import script from "./BigButtonGroup.vue?vue&type=script&lang=js"
export * from "./BigButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./BigButtonGroup.vue?vue&type=style&index=0&id=8a014238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a014238",
  null
  
)

export default component.exports